import { render, staticRenderFns } from "./ConfirmModalVacinacao.vue?vue&type=template&id=01d3f83d&"
import script from "./ConfirmModalVacinacao.vue?vue&type=script&lang=js&"
export * from "./ConfirmModalVacinacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports